import * as d3 from 'd3';
import $ from 'jquery';
import SVG from 'svgjs';

let cx = null;
let cy = null;
let min = null;
let max = null;

let slices = null;
let angleOffset = null;
let angleSlice = null;
let r0 = null;
let ringWidth = null;
let levels = null;

const x = (angle, r) => {
  return cx + r * Math.cos(angle);
};

const y = (angle, r) => {
  return cy + r * Math.sin(angle);
};

const adapt = function(arr) {
  // Adds one to each value (in response to 10/11 change: 0 should be drawn on the first line, not the innermost, invisible ring)
  // Then normalizes it
  arr.forEach(function(value, i) {
    value = value;
    arr[i] = (value - min) / (max - min);
  });
  return arr;
};

export const createRadar = function(settings) {
  var TWO_PI = 2 * Math.PI;
  var PI = Math.PI;
  angleOffset = PI / 2;
  // var angleOffset = 3*PI/2; // Do this for starting with vertical line
  let axes = settings.axes;
  min = settings.range.min;
  max = settings.range.max;
  levels = max;
  slices = axes.length;
  angleSlice = TWO_PI / slices;

  let interpretations = settings.interpretations;

  let divId = settings.el;
  let w = 500;
  let h = 500;
  cx = w / 2;
  cy = h / 2;
  let radius = 200;
  r0 = 65; // First ring radius is large
  ringWidth = (radius - r0) / levels;

  // Add class to parent div so that our css selectors can be scoped
  $('#' + divId).addClass('radar-chart');
  var gridLines = [];
  var draw = SVG(divId).size(w, h);

  var levelColors = ['#8b84d7', '#29adff', '#29adff', '#7455ff', '#7455ff']; //TOD0: next iteration, interpolate between the extremes for the dots
  var gradient = draw.gradient('radial', function(stop) {
    stop.at(0, levelColors[0]);
    stop.at(1, levelColors[4]);
  });

  // Circle to test gradient
  var circle = draw
    .circle(radius * 2)
    .cx(w / 2)
    .cy(h / 2)
    .fill('#fff')
    .opacity(0.5);
  circle.attr({ fill: gradient });

  var polygonPoints = [];

  // Draw rings + Radial lines
  for (var axis = 0; axis < slices; axis++) {
    var angle = angleOffset + angleSlice * axis;

    // Deprecated: we're not highlighting the current ring anymore
    // Determine which ring is nearest the current data point
    // var dataLevel = Math.abs(axes.value * levels);

    // Draw rings
    for (var level = 0; level <= 4; level++) {
      // Draw line from current axis to next axis
      var r = r0 + ringWidth * level;
      if (level == 0) {
        r = r0;
      }
      if (level > 0) {
        var x2 = x(angle, r);
        var y2 = y(angle, r);
        var x3 = x(angle + angleSlice, r);
        var y3 = y(angle + angleSlice, r);
        var line = draw
          .line(x2, y2, x3, y3)
          .stroke({ color: '#4d4d4f', width: 2 })
          .back();
      }

      // Draw level interpretation
      if (axis == 3 && level >= 0 && level < 4) {
        draw
          .text('' + interpretations[level])
          .fill('#222222')
          .font({
            size: 14,
            family: 'GTAR',
            weight: level === 0 ? 'bold' : 'normal'
          })
          .attr('text-anchor', 'middle')
          .x(cx) // x2 - 25
          .y(y2 - ringWidth + 10) // y2 - ringWidth / 2 - 5
          .back();
      }

      // Deprecated (design changed)
      // Highlight rings that have data on them
      // if(level <= 3){ //for now, arbitrarily highlighting the third and fourth
      //     line.stroke({color:levelColors[level], width:3})
      //       .back();
      // }

      // Draw radial lines (from level 1 ring to outer ring)
      if (level == 1) {
        draw
          .line(x2, y2, x(angle, radius), y(angle, radius))
          .stroke({ color: '#4d4d4f', width: 3 })
          .back();
      }
    }

    // Draw data circles
    // By default, all points start at center
    var pos = 0;

    // Store data point for drawing polygon later
    var point = [x(angle, pos), y(angle, pos)];

    draw
      .circle(8)
      .attr('id', 'data_circle_' + axis)
      .cx(point[0])
      .cy(point[1])
      .fill('none')
      .stroke({ color: 'none' });
    polygonPoints.push(point);

    // Draw axis label
    var radiusScale = 1.09;
    if (axis == 0) {
      // Bottom axis
      radiusScale = 1.2;
    }

    var line1 = draw
      .text('' + axes[axis].line1)
      .fill('#222222')
      .font({ size: 16, family: 'GTAR' })
      .width(2)
      .x(x(angle, radius * radiusScale))
      .y(y(angle, radius * radiusScale) - 10);
    if (axes[axis].line1 === 'Medication') {
      line1.x(x(angle, radius * radiusScale) - 10.98);
    } else {
      line1.x(x(angle, radius * radiusScale));
    }

    var line2 = draw
      .text('' + axes[axis].line2)
      .fill('#222222')
      .font({ size: 16, family: 'GTAR' })
      .x(x(angle, radius * radiusScale))
      .y(y(angle, radius * radiusScale) + 10);

    if (axis == 0) {
      line1.attr('text-anchor', 'middle');
      line2.attr('text-anchor', 'middle');
    } else if (axis >= 1 && axis <= 3) {
      line1.attr('text-anchor', 'end');
      line2.attr('text-anchor', 'end');
    }
  }

  // Draw polygon area
  var polygon = draw
    .polygon(polygonPoints)
    .attr('id', 'poly')
    .opacity(0.3)
    .fill(gradient);
  polygon.front();

  // Color area with circle gradient by clipping it
  circle.clipWith(polygon);

  // Draw center number
  draw
    .text(' ') //
    .attr('id', 'centerValue')
    .font({ size: 32, family: 'GTAM', fill: '#222222' })
    .x(cx)
    .y(cy - 35)
    .attr('text-anchor', 'middle');

  var deferred = new $.Deferred();
  deferred.resolve('resolved');
  return deferred;
};

export const updateRadar = function(data) {
  let dataValue = adapt(data.chartData);
  let centerValue = data.centerValue;

  // TODO: instead of adding, modify existing by selecting them:
  var polygonPoints = [];
  for (var axis = 0; axis < slices; axis++) {
    var angle = angleOffset + angleSlice * axis;

    var pos = r0 + ringWidth * levels * dataValue[axis];
    var point = [x(angle, pos), y(angle, pos)];

    SVG.get('data_circle_' + axis)
      .animate(300)
      .cx(point[0])
      .cy(point[1]);

    polygonPoints.push(point);
  }

  SVG.get('poly')
    .animate(300)
    .plot(polygonPoints);
  SVG.get('centerValue').text(centerValue + '');
};
